import { faBagShopping } from "@jewlr/pro-light-svg-icons/faBagShopping"
import PropTypes from "prop-types"
import { useEffect } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import { fetchCartList } from "app-store-v2/header/actions"
import NavIcon from "areas/header/nav-icon"

const CartIcon = ({ count, fetchCartList, isMobile, onNavClick }) => {
  useEffect(() => {
    fetchCartList()
  }, [])

  return (
    <Link
      aria-label="Cart"
      className="relative inline-block"
      data-cy={`header-cart-icon-${isMobile ? "mobile" : "desktop"}`}
      data-lc="cart-icon"
      onClick={onNavClick}
      to="/cart"
    >
      <NavIcon icon={faBagShopping} />
      {count > 0 && (
        <div className="bg-link text-10 size-15 absolute -right-8 -top-6 flex items-center justify-center rounded-full text-center text-white">
          {count}
        </div>
      )}
    </Link>
  )
}

CartIcon.propTypes = {
  count: PropTypes.number,
  fetchCartList: PropTypes.func,
  isMobile: PropTypes.bool,
  onNavClick: PropTypes.func,
}

const mapStateToProps = (state) => ({
  count: state.cart.count,
})

const mapDispatchToProps = (dispatch) => ({
  fetchCartList: () => dispatch(fetchCartList()),
})

export default connect(mapStateToProps, mapDispatchToProps)(CartIcon)
